import { FormControl, FormLabel } from "@mui/material";
import { ReactNode } from "react";

type FormLegendProps = {
  children: ReactNode;
};

export default function FormLegend({ children, ...rest }: FormLegendProps) {
  return (
    <FormControl sx={{ width: "100%" }} component="fieldset" {...rest}>
      <FormLabel sx={(theme) => theme.typography.formLegend} component="legend">
        {children}
      </FormLabel>
    </FormControl>
  );
}
